import { DateTime } from '@ksyos/date-time';
import { Box, Button, ButtonRow } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { ProcessStartWizardRow } from '@frontend/components/elements/ProcessStartWizard/ProcessStartWizardRow';
import { DatePickerFormGroupField } from '@frontend/components/fields/DatePickerField';
import { TextInputFormGroupField } from '@frontend/components/fields/TextInputField';
import { getSelectedLanguage } from '@frontend/translate';

interface IPatientSearchBarProps {
    canCreateAndSeeAllPatients: boolean;
    header?: boolean;
    onSearch: () => void;
    text: string;
}

export function PatientSearchBar(props: IPatientSearchBarProps) {
    const translate = getSelectedLanguage();
    const navigate = useNavigate();

    return (
        <ProcessStartWizardRow
            header={props.header}
            label={props.text}
            wrapChildren={false}
        >
            <Box
                display="grid"
                flex="1"
                gridTemplateColumns={[
                    '1fr',
                    null,
                    null,
                    `minmax(0, 1fr) minmax(0, 1fr) min-content`,
                    `minmax(0, 1fr) minmax(0, 1fr) min-content minmax(0, 1fr) max-content`,
                ]}
                sx={{ columnGap: 2 }}
            >
                <TextInputFormGroupField
                    fieldKey="nameFamily"
                    label=""
                    layout="vertical"
                    onEnterKeyPress={props.onSearch}
                    placeholder={translate.common.name}
                />
                <TextInputFormGroupField
                    dontValidateOnChange={true}
                    fieldKey="identifierSocialSecurity"
                    label=""
                    layout="vertical"
                    onEnterKeyPress={props.onSearch}
                    placeholder={translate.patient.identifierSocialSecurity}
                />
                <DatePickerFormGroupField
                    color="secondary"
                    fieldKey="birthDate"
                    label=""
                    layout="vertical"
                    maxValue={DateTime.now().toDate()}
                />
                <TextInputFormGroupField
                    fieldKey="processNumber"
                    label=""
                    layout="vertical"
                    onEnterKeyPress={props.onSearch}
                    placeholder="Proces ID"
                />
                <ButtonRow
                    isStackedBelowSmall={true}
                    sx={{ alignItems: [null, 'flex-start'] }}
                >
                    <Button
                        className="automation-patientSearchBarButtonSearch"
                        color="secondary"
                        data-automation-test="patientSearchBarButtonSearch"
                        onClick={() => props.onSearch()}
                        variant="outline"
                    >
                        {translate.common.search}
                    </Button>
                    {props.canCreateAndSeeAllPatients && (
                        <Button
                            color="secondary"
                            iconLeft="add"
                            onClick={handleClick}
                            variant="link"
                        >
                            {translate.patient.newPatient}
                        </Button>
                    )}
                </ButtonRow>
            </Box>
        </ProcessStartWizardRow>
    );

    function handleClick() {
        navigate('/patients/newPatient/');
    }
}
